import { operations } from '@showbie-socrative/socrative-utils/lib/config/workspaceUserPermissions.json';

import { createComposePermission } from './createComposePermissions';

export const composePermissions = createComposePermission(operations);
